import type { EntryGateStatus } from '@core/entities/EntryGateStatus';

export interface EntryGatePageViewModel {
  outcome: EntryGateStatus['outcome'];
  title: string;
  message: string;
  guidanceHeading?: string;
  guidancePoints?: string[];
  denialReason?: string;
  returnUri: string;
}

export class EntryGatePresenter {
  public presentStatus(status: EntryGateStatus): EntryGatePageViewModel {
    return {
      outcome: status.outcome,
      title: status.title,
      message: status.message,
      denialReason: status.denialReason ?? undefined,
      returnUri: status.returnUri
    };
  }
}